import './social_profile_view.js.coffee'
Namespace 'Customer.Users'

class Customer.Users.TikTokProfileView extends Customer.Users.SocialProfileView
  template: JST['backbone/templates/customer/users/tiktok_profile']
  id: 'tiktok-profile'
